import { FC } from 'react'

import { IconShieldCheck } from '@sequencehq/core-components'

import { NodeIconTemplate } from 'Automations/nodeDefinitions/components'
import { IconProps } from '../../types'

export const ReviewIcon: FC<IconProps> = ({ boxSize, theme = 'orange' }) => {
  return (
    <NodeIconTemplate
      icon={<IconShieldCheck />}
      theme={theme}
      boxSize={boxSize}
    />
  )
}
